import { render, staticRenderFns } from "./ProfileProvider.vue?vue&type=template&id=d6c2cec2"
import script from "./ProfileProvider.vue?vue&type=script&lang=js"
export * from "./ProfileProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports